import React, { useEffect, useState, Children } from 'react';
import { useLocation } from 'react-router-dom';
interface PageTransitionProps {
  children: React.ReactNode;
}
export const PageTransition: React.FC<PageTransitionProps> = ({
  children
}) => {
  const {
    pathname
  } = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionStage, setTransitionStage] = useState('fadeIn');
  useEffect(() => {
    // Instantly jump to top of page when route changes
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    if (children !== displayChildren) {
      // Start fade out transition
      setTransitionStage('fadeOut');
      // After fade out completes, update children and start fade in
      const timeout = setTimeout(() => {
        setDisplayChildren(children);
        setTransitionStage('fadeIn');
      }, 200); // Match this with the CSS fadeOut duration
      return () => clearTimeout(timeout);
    }
  }, [children, displayChildren]);
  return <div className={`page-transition ${transitionStage}`} data-id="element-389">
      {displayChildren}
    </div>;
};